import {Component, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {AuthLayoutComponent} from '../auth-layout/auth-layout';

@Component({
  selector: 'app-validation-code',
  standalone: true,
  imports: [
    AuthLayoutComponent
  ],
  templateUrl: './validation-code.html',
  styleUrl: './validation-code.scss'
})
export class ValidationCodeComponent {
  private code: string[] = ['', '', '', ''];

  @ViewChildren('codeInput') inputs!: QueryList<ElementRef>;

  onInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;

    input.value = input.value.replace(/[^0-9]/g, '');

    if (input.value.length > 0) {
      this.code[index] = input.value;
      if (index < 3) {
        const inputsArray = this.inputs.toArray();
        inputsArray[index + 1].nativeElement.focus();
      }
    }
  }

}
